import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Surface, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import ExplicitInformedConsent from '@app/components/ExplicitInformedConsent';
import { selectChangePlan, setConsentChecked, setScrollToTransitionConsent } from '@app/redux/changePlan';

import OrderDetailsSection from '../OrderDetailsSection';

type DisclosureProps = {
  isEicChecked: boolean;
  hasAttemptedSubmit: boolean;
};

const Disclosure = ({ isEicChecked, hasAttemptedSubmit }: DisclosureProps) => {
  const { t } = useTranslation('ChangePlan');
  const dispatch = useDispatch();
  const { eicMessage, scrollToConsent } = useSelector(selectChangePlan);
  const consentRef = useRef<HTMLInputElement>(null);

  const handleCheckboxChange = () => {
    dispatch(setConsentChecked(!isEicChecked));
  };

  useEffect(() => {
    if (scrollToConsent && consentRef.current) {
      consentRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });

      dispatch(setScrollToTransitionConsent(false));
    }
  }, [scrollToConsent, dispatch]);

  return (
    <Surface>
      <Txt variant="labelSmall" color="subtle" mb={'40px'} component="p">
        {t('disclosure.title')}
      </Txt>

      <OrderDetailsSection id="disclosure">
        <ExplicitInformedConsent
          id="change_plan_disclosure"
          label={`${t('disclosure.checkbox.label')}`}
          isChecked={isEicChecked}
          onChange={handleCheckboxChange}
          hasError={hasAttemptedSubmit && !isEicChecked}
          errorMessage={`${t('disclosure.checkbox.errorMessage')}`}
          disclosureText={eicMessage ? eicMessage.eicMessage : []}
          consentRef={consentRef}
        />
      </OrderDetailsSection>
    </Surface>
  );
};

export default Disclosure;
